import React from "react";
import Link, { ExternalLink } from "./Link";

const PatreonPlanInfo = ({ plan: { level } }) => (
  <span>
    {parseFloat(level) <= 100 ? (
      <span>
        <span role="img" aria-label="thanks">
          🙏
        </span>{" "}
        <ExternalLink href="https://www.patreon.com/benjie">
          Patreon
        </ExternalLink>
        : pay what you can
      </span>
    ) : (
      <span>
        <span role="img" aria-label="thanks">
          🙌
        </span>{" "}
        <ExternalLink href="https://www.patreon.com/benjie">
          Patreon
        </ExternalLink>
        : ${(level / 100).toFixed(2)}
        /mo+ supporters
      </span>
    )}
  </span>
);

const GitHubPlanInfo = ({ plan: { level } }) => (
  <span>
    {parseFloat(level) <= 100 ? (
      <span>
        <span role="img" aria-label="thanks">
          🙏
        </span>{" "}
        <ExternalLink href="https://graphile.org/sponsor/">
          GitHub Sponsors
        </ExternalLink>
        : pay what you can
      </span>
    ) : (
      <span>
        <span role="img" aria-label="thanks">
          🙌
        </span>{" "}
        <ExternalLink href="https://graphile.org/sponsor/">
          GitHub Sponsors
        </ExternalLink>
        : ${(level / 100).toFixed(2)}
        /mo+ supporters
      </span>
    )}
  </span>
);

const StripePlanInfo = ({ plan: { planInfo, id } }) => {
  if (
    planInfo &&
    planInfo.amount &&
    planInfo.currency &&
    planInfo.intervalCount === 1 &&
    planInfo.interval
  ) {
    const currency = planInfo.currency.toUpperCase();
    const currencySymbol =
      {
        GBP: "£",
        USD: "$",
        EUR: "€",
      }[currency] || "";
    return (
      <span>
        <span role="img" aria-label="credit card">
          💳
        </span>{" "}
        Credit card:{" "}
        <Link to={`/settings/change-plan?plan=${id}`}>
          {currencySymbol}
          {(planInfo.amount / 100).toFixed(
            2
          )} {planInfo.currency.toUpperCase()} / {planInfo.interval}
        </Link>
      </span>
    );
  }
  return null;
};

export const Plan = ({ plan /*, GetComponent = () => null */ }) =>
  plan.source === "github" ? (
    <GitHubPlanInfo plan={plan} />
  ) : plan.source === "patreon" ? (
    <PatreonPlanInfo plan={plan} />
  ) : plan.source === "stripe" ? (
    <StripePlanInfo plan={plan} />
  ) : null;

export const PlanName = ({ prefix }) =>
  ({
    bronze: "Bronze Plan",
    silver: "Silver Plan",
  }[prefix] || prefix);

export const PlanDescription = ({ prefix }) =>
  prefix === "bronze"
    ? "Our basic self-service offering, excludes commercial support."
    : prefix === "silver"
    ? "Our professional offering, includes all the features of the Bronze Plan."
    : "";
